import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button, Divider, Link } from '@prezi/bento';
import { selectDocument, selectViewlinks } from '../../../../store';
import { viewLinkActions } from '../../../../store/actions/viewLinkActions';
import { getViewlinkUrl } from '../../../../api/viewlink';
import { ColumnAutoMin, FooterContainer, InnerScreenGrid, RowGap, RowGrid, SimpleSectionHeader, Button as ButtonAlt } from '../../../atoms/dumb';
import * as Molecules from '../../../molecules';
import DeactivationModal from './DeactivationModal';
import LinkNameInput from './LinkNameInput';
import { ToggleAnalytics, ToggleRequireEmail } from './analyticsToggleButtons';
import { createDataLookup } from '../../../const';
import analyticsControlContextSelector from '../analyticsControlContextSelector';
import { localI18n } from '../../../../i18n';
import { isActive } from '../../../../featureswitches/Features';
const uxCopy = {
  header: localI18n._("Link settings"),
  subheading: localI18n._("Link settings"),
  viewAnalyticsButton: localI18n._("View on Prezi Analytics"),
  cancelButton: localI18n._("Cancel"),
  saveButton: localI18n._("Save"),
  deactivateButton: localI18n._("Deactivate Link")
};
const Footer = styled(FooterContainer).withConfig({
  displayName: "LinkSettings__Footer",
  componentId: "sc-1y50vgw-0"
})(["display:flex;justify-content:space-between;"]);
const SimpleSection = styled.div.withConfig({
  displayName: "LinkSettings__SimpleSection",
  componentId: "sc-1y50vgw-1"
})(["padding-top:20px;padding-bottom:20px;"]);
const LinkSettings = ({
  goBack,
  linkId
}) => {
  var _referralState$value, _referralState$value$, _referralState$value2, _referralState$value3;
  const dispatch = useDispatch();
  const {
    value: viewLinks
  } = useSelector(selectViewlinks);
  const {
    value: document
  } = useSelector(selectDocument);
  const analyticsControlContext = useSelector(analyticsControlContextSelector);
  const referralState = useSelector(state => state.referral);
  const showReferralInfo = useSelector(state => state.showReferralCopyAndCode);
  const shouldAddReferralToken = showReferralInfo && (referralState === null || referralState === void 0 ? void 0 : (_referralState$value = referralState.value) === null || _referralState$value === void 0 ? void 0 : (_referralState$value$ = _referralState$value.tokens) === null || _referralState$value$ === void 0 ? void 0 : _referralState$value$.ln) && isActive('gm-share-modal-share-link-improvements');
  const referralToken = shouldAddReferralToken ? referralState === null || referralState === void 0 ? void 0 : (_referralState$value2 = referralState.value) === null || _referralState$value2 === void 0 ? void 0 : (_referralState$value3 = _referralState$value2.tokens) === null || _referralState$value3 === void 0 ? void 0 : _referralState$value3.ln : undefined;
  const viewLinkItem = viewLinks.byId[linkId];
  const viewlinkUrl = getViewlinkUrl(viewLinkItem.link_id, document === null || document === void 0 ? void 0 : document.schema_version_name, referralToken);
  const [linkName, setLinkName] = React.useState(viewLinkItem.name);
  const [isAnalyticsEnabled, setIsAnalyticsEnabled] = React.useState(viewLinkItem.visible_on_analytics);
  const [isViewerIdentificationRequired, setIsViewerIdentificationRequired] = React.useState(viewLinkItem.viewer_identification);
  const [isDeactivationModalOpen, setDeactivationModalOpen] = React.useState(false);
  React.useEffect(() => {
    if (!isAnalyticsEnabled) {
      setIsViewerIdentificationRequired(false);
    }
  }, [isAnalyticsEnabled]);
  return React.createElement(React.Fragment, null, React.createElement(InnerScreenGrid, {
    rowGap: RowGap.none
  }, React.createElement(Molecules.Dumb.Header, {
    onBack: goBack,
    removeBottomBorder: true
  }, uxCopy.header), React.createElement(SimpleSection, null, React.createElement(RowGrid, null, React.createElement(LinkNameInput, {
    value: linkName,
    onChange: setLinkName
  }), React.createElement(RowGrid, null, React.createElement(Molecules.Dumb.ViewLinkCopySecondary, {
    viewLink: viewlinkUrl,
    handleCopyToClipboard: () => dispatch(viewLinkActions.copyToClipboard(viewlinkUrl))
  }), React.createElement(Divider, null), React.createElement(SimpleSectionHeader, null, uxCopy.subheading), React.createElement(ToggleAnalytics, {
    handleOnChange: setIsAnalyticsEnabled,
    checked: isAnalyticsEnabled,
    controlContext: analyticsControlContext
  }), React.createElement(ToggleRequireEmail, {
    handleOnChange: setIsViewerIdentificationRequired,
    checked: isViewerIdentificationRequired,
    controlContext: analyticsControlContext.disabled ? analyticsControlContext : {
      disabled: !isAnalyticsEnabled
    }
  }), viewLinkItem.visible_on_analytics && React.createElement(Link, {
    href: `/analytics/${linkId}`,
    target: "_blank",
    "data-lookup": createDataLookup('view-on-analytics-link')
  }, uxCopy.viewAnalyticsButton)))), React.createElement(Footer, null, React.createElement(Button, {
    variant: "danger",
    onClick: () => setDeactivationModalOpen(true),
    "data-lookup": createDataLookup('deactivate-link-button')
  }, uxCopy.deactivateButton), React.createElement(ColumnAutoMin, null, React.createElement(ButtonAlt, {
    variant: "transparent",
    onClick: goBack,
    "data-lookup": createDataLookup('cancel-button')
  }, uxCopy.cancelButton), React.createElement(Button, {
    variant: "primary",
    onClick: () => {
      dispatch(viewLinkActions.updateViewlink(linkId, viewLinkItem, {
        ...viewLinkItem,
        name: linkName,
        visible_on_analytics: isAnalyticsEnabled,
        viewer_identification: isViewerIdentificationRequired
      }));
      goBack();
    },
    disabled: viewLinkItem.name === linkName && viewLinkItem.viewer_identification === isViewerIdentificationRequired && viewLinkItem.visible_on_analytics === isAnalyticsEnabled,
    "data-lookup": createDataLookup('save-view-link-button')
  }, uxCopy.saveButton)))), React.createElement(DeactivationModal, {
    isOpen: isDeactivationModalOpen,
    onClose: () => setDeactivationModalOpen(false),
    canDeleteData: true,
    handleDeactivateLink: deleteData => {
      setDeactivationModalOpen(false);
      dispatch(viewLinkActions.removeViewlink(linkId, deleteData));
      goBack();
    }
  }));
};
export default LinkSettings;